module.exports = __webpack_public_path__ + "static/seychellen-5db54720b1485746d562783c7e75bc4d.svg";